import {
  validateFormat,
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence(true),
    validateLength({ min: 1 }),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
  abbreviation: [validateFormat({ type: 'string', allowBlank: true })],
  initiative_doc: [
    validateFormat({ type: 'url', allowBlank: true }),
    validateFormat({
      regex: /^(http|https):\/\//,
      allowBlank: true,
      message: 'Please ensure your url contains http(s)://',
    }),
  ],
  approach: [
    validateFormat({ type: 'url', allowBlank: true }),
    validateFormat({
      regex: /^(http|https):\/\//,
      allowBlank: true,
      message: 'Please ensure your url contains http(s)://',
    }),
  ],
  description: [validateFormat({ type: 'string', allowBlank: true })],
  source: [validateFormat({ type: 'string', allowBlank: true })],
  status: [validateFormat({ type: 'string', allowBlank: true })],
  bon_value: [validateFormat({ type: 'number', allowBlank: true })],
  bon_investment: [validateFormat({ type: 'number', allowBlank: true })],
  bon_returns: [validateFormat({ type: 'number', allowBlank: true })],
  starting_week: [validateFormat({ type: 'string', allowBlank: true })],
  start_date: [validateFormat({ type: 'string', allowBlank: true })],
};
